import { useState, useEffect, useMemo } from 'react';
import axios from 'axios';
import moment from 'moment';
import endpoints from '../define/endpoints';

const useAvailabilities = (listingId, productId) => {
  const [availabilities, setAvailabilities] = useState([]);
  const [availabilitiesPerDate, setAvailabilitiesPerDate] = useState([]);
  const [date, setDate] = useState(null);

  useEffect(() => {
    const fetchAvailabilities = async () => {
      if (!listingId && !productId) return;
      try {
        const { data } = await axios.get(`${endpoints.core}/availabilities`, {
          params: {
            id_listing: listingId,
            id_product: productId,
            locale: window.freedomeConfig.locale,
          },
        });

        setAvailabilities(data);
      } catch (err) {
        // console.error(err);
      }
    };

    fetchAvailabilities();
  }, [listingId, productId]);

  useEffect(() => {
    if (!date) return;

    const filteredAvailabilities = availabilities
      .map((availability) => {
        const momentDate = moment(availability.datetime);
        return {
          id: availability.id,
          label: momentDate.format('HH:mm'),
          value: momentDate,
          price: availability.price,
          openSeats: availability.open_seats,
        };
      })
      .filter((availability) => availability.value.isSame(date, 'day'));

    setAvailabilitiesPerDate(filteredAvailabilities);
  }, [date, availabilities]);

  const dayMap = useMemo(() => {
    if (!availabilities.length) return {};
    const map = {};
    availabilities.forEach((availability) => {
      map[moment(availability.datetime).format('YYYYMMDD')] = true;
    });
    return map;
  }, [availabilities]);

  const isDayBlocked = (day) => {
    return !dayMap[day.format('YYYYMMDD')];
  };

  return {
    availabilities,
    availabilitiesPerDate,
    date,
    setDate,
    isDayBlocked,
  };
};

export default useAvailabilities;
